import useSWR from "swr";
import { fetcher } from "../../../services/fetcher";
import { PAYMENTS_STATS_ENDPOINT, PAYMENTS_SWR_CONFIG } from "../utils/paymentConstants";

const usePaymentStats = (filterQuery = "") => {
  const url = filterQuery
    ? `${PAYMENTS_STATS_ENDPOINT}?${filterQuery}`
    : PAYMENTS_STATS_ENDPOINT;

  const { data, isLoading } = useSWR(url, fetcher, PAYMENTS_SWR_CONFIG);

  return { stats: data, loading: isLoading };
};

export default usePaymentStats;
